import React, { useState } from "react";
import agentImg from "../assets/dp.jpg";

const WhatsAppButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const phoneNumber = "16475504350";
  const message = "";
  const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div>
      {/* WhatsApp Modal */}
      {isModalOpen && (
        <div className="fixed bottom-[80px] right-5 z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-xs w-full border">
            {/* Header */}
            <div className="flex items-center p-4 bg-teal-600 rounded-t-lg">
              <div className="w-12 h-12 rounded-full overflow-hidden">
                <img
                  src={agentImg}
                  alt="Help"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="ml-3 text-white">
                <div className="font-bold text-lg">Devan Arora</div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                  <div className="text-sm">Online</div>
                </div>
              </div>
              <button className="ml-auto text-white" onClick={toggleModal}>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M14.29 14.29L10 10l4.29-4.29-1.42-1.42L10 8.59 5.71 4.29 4.29 5.71 8.59 10l-4.3 4.29 1.42 1.42L10 11.41l4.29 4.3z" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-4">
              <div className="text-gray-800">
                <p className="font-semibold">Devan Arora</p>
                <p className="text-sm">
                  Hi there! 🌟 🏡 Looking for your dream home or planning to sell?
                  Let's chat about your real estate goals and make them happen. How
                  can I assist you?
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="p-4 bg-gray-100 rounded-b-lg text-center">
              <a
                className="inline-block px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition duration-200"
                href={whatsappLink}
                target="_blank"
                rel="noreferrer noopener"
              >
                Click to Start Chat
              </a>
            </div>
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        className="fixed bottom-5 right-5 z-40 p-3 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 transition duration-200"
        onClick={toggleModal}
      >
        Chat on WhatsApp
      </button>
    </div>
  );
};

export default WhatsAppButton;
